<template>
	<div class="box">
        <div class="field">
            <p class="title">Upload Document</p>
        </div>

        <hr style="margin-left:25px;margin-right:25px;"/>

        <b-form-file
            class="upload-box text-nowrap text-truncate"
            size="lg"
            v-model="uploadFiles"
            :state="Boolean(uploadFiles)"
            placeholder="Choose or Drop file here"
            drop-placeholder="Drop file here"
			@input="select()"
			multiple
        ></b-form-file>
		<br/>
		<img v-if="uploadFiles.length>0" id="file_upload" src="#" style="width:30%"></img>
		<p id="more"></p>

		<hr style="margin-left:25px;margin-right:25px;"/>

		<div class="uploading-box" v-bind:class="{ hidden: !loading }">
			<div v-bind:id="'loading-progress'" class="uploading-bar-green" v-bind:style="'width:'+loadingBarWidth+'%'"></div>
		</div>
		<button :disabled="!ready" v-on:click="upload()" v-bind:class="{ hidden: uploading}">Upload</button>
		<div class="uploading-box" v-bind:class="{ hidden: !uploading }">
			<div v-bind:id="'progress'" class="uploading-bar">
				<p v-bind:id="'progress-text'" class="upload-text"></p>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_DOCUMENTS_PAGE,
			uploadFiles:[],
			files:[],
			uploading:false,
			loading:false,
			ready:false,
			progressBar:null,
			loadingBar:null,
			loadingBarWidth:0,
		}
	},
	methods:{
		select(){
			this.file=null;
			this.loading=true;
			this.ready=false;
			this.loadingBarWidth = 0
			var length = this.uploadFiles.length

			var widths = []
			var promises = []

			for(let i = 0;i<length;i++){
				promises.push(new Promise((resolve, reject) => {
					var reader = new FileReader()
					reader.onload = function(e){
						document.getElementById("file_upload").src = e.target.result
						this.files[i] = {imageName:this.uploadFiles[i].name, imageData:e.target.result}
						resolve(null);
					}.bind(this);

					reader.onprogress = function(e){
						if (e.lengthComputable) {
			                widths[i] = parseInt( (((e.loaded / e.total) * 100) / length), 10 );
							this.loadingBarWidth = widths.reduce((a, b) => a + b, 0)
			            }
					}.bind(this);

					reader.onerror = function(e){
						console.log(e)
						this.uploading=false;
						this.loading=false;
						this.ready=false;
						this.uploadFiles = []
						this.files = []
						document.getElementById("file_upload").src = "#"
						document.getElementById("more").innerHTML = ""

						alert("error: File could not be read")
						reject(null);
					}.bind(this);

					reader.readAsDataURL(this.uploadFiles[i])
		        }));
			}

			Promise.all(promises).then((results) => {
				this.loading=false;
				this.ready=true;

				if(length>1){
					document.getElementById("more").innerHTML = "+ "+(this.uploadFiles.length-1)+" more"
				}else{
					document.getElementById("more").innerHTML = ""
				}
			});

		},
		upload(){
			this.uploading=true;
			this.ready=false;
			this.progressBar.style = "width:0%"
			var fileCount = this.files.length

			api.postDataImage(
				{
					data:{
						pageid:this.pageid,
						files:this.files
					}
				},
				this.progressBar
			).then((res) => {

				this.uploadFiles = []
				this.files = []
				document.getElementById("file_upload").src = "#"
				document.getElementById("more").innerHTML = ""

				alert(res.data.message)
			}).finally((res) => {
				this.uploading=false;
				this.loading=false;
				this.ready=false;
			})
		}
	},
	mounted: function () {
		this.$nextTick(function () {
			this.progressBar = document.getElementById("progress")
			this.loadingBar = document.getElementById("loading-progress")
			this.progressBar.style = "width:0%"
			this.loadingBar.style = "width:0%"
		})
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    text-align:center;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

.upload-box{
    width:75%;
}

.custom-file-input ~ .custom-file-label::after {
  content: 'sh';
}

</style>



// WEBPACK FOOTER //
// src/components/add/Add_Documents.vue